import api from '../../api/api'

const state = {
  Token: '',
  noReadTotal: 0, // 未阅读条数
  Info: {},
  isMemberYear: false, //年费会员
  isMemberMonth: false ,//季度会员
  isMemberControl: false,
  closeMember: false,
  isShowApp:true,//是否全局显示app下载栏
}

const getters = {
  Token: function (state) {
    return state.Token
  },
  noReadTotal: function (state) {
    return state.noReadTotal
  }
}

const mutations = {
  userToken(state, res) {
    state.Token = res.data
  },
  noReadTotal(state, res) {
    state.noReadTotal = res
  },
  userInfo(state, res) {
    state.Info = res.data
  },
  isMemberYearChange(state, res) {//年费会员
    state.isMemberYear = res
  },
  isMemberMonthChange(state, res) {//季度会员
    state.isMemberMonth = res
  },
  closeMemberChange(state, res) {
    state.closeMember = res
  },
  startMemberControl(state, res) {
    state.isMemberControl = res
  },
  closeAppDown(state, res){
    state.isShowApp = res
  }
}

const actions = {
  // 密码登录，返回值为Token，将Token存储在全局状态
  loginPassword(context, payload) {
    return new Promise((resolve, reject) => {
      api.user.loginPassword(payload.password, payload.phoneNum).then(res => {
        if (res) {
          context.commit('userToken', res)
          resolve()
        }
      })
    })
  },
  //注册验证 接口：手机号注册验证
  RegisterWithPhoneNoVerify(context, payload) {
    return new Promise((resolve, reject) => {
      api.user.RegisterWithPhoneNoVerify(payload.registerCode, payload.registerPasseWord, payload.registerPhone).then(res => {
        context.commit('userToken', res)
        resolve(res)
      }).catch(res => {
        reject(res)
      })
    })

  },
  isShowAppDown(context, payload){
      context.commit('closeAppDown', false)
  },
  // 当用户登录后获取当前用户信息
  getCurrentUser(context, payload) {
    return new Promise((resolve, reject) => {
      api.user.getCurrentUser().then(res => {
        context.commit('userInfo', res)
        // ******涉及会员 身份鉴别******
        if(res.data.Account.VipEndAt){
          //有会员印记

          var nowDate=new Date();
          var stmp = res.data.Account.VipEndAt;
          var userDate=new Date();
          userDate.setFullYear(stmp.slice(0,4),stmp.slice(5,7),stmp.slice(8,10));
          //会员到期时间

          var stmpBegin = res.data.Account.VipBeginAt;
          var userDateBegin=new Date();
          userDateBegin.setFullYear(stmpBegin.slice(0,4),stmpBegin.slice(5,7),stmpBegin.slice(8,10));

          if(userDate>nowDate){
            //******单独控制弹窗显示 
            context.commit('startMemberControl', true)
            //"会员未到期
            // "会员开始时间戳",userDateBegin.getTime()
            // "会员结束时间戳",userDate.getTime()
            //(userDate.getTime()-userDateBegin.getTime())/1000/60/60/24
            if((userDate.getTime()-userDateBegin.getTime())/1000/60/60/24>100){
              //"是年费会员",(userDate.getTime()-userDateBegin.getTime())/1000/60/60/24
              context.commit('isMemberYearChange', true)
            }else{
              // "会员天数",(userDate.getTime()-userDateBegin.getTime())/1000/60/60/24
              context.commit('isMemberMonthChange', true)
            }
          }else{
          }
        }else{
        }
        resolve(res)
      }).catch(res => {
        reject(res)
      })
    })
  }
  //******修改365会员弹窗状态 */
  ,closeMemberChangeNow(context, payload){
    context.commit('closeMemberChange', payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/vuex/modules/user.js